export const ADD_MMR_CALCULATED_VALUE = 'ADD_MMR_CALCULATED_VALUE';
export const CLEAR_MMR_CALCULATED_VALUE = 'CLEAR_MMR_CALCULATED_VALUE';
